<template>
  <div class="content min-w-1215">
    <PageHeader :title="`稼働`">
      <template #title-header-content>
        <div class="flex-1 flex justify-end items-center">

          <div class="bg-white flex text-white font-bold text-sm p-2 rounded mx-auto w-fit">
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==0?'bg-blue-700':'bg-gray-400'" @click="clickTitle(0)">進捗</div>
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==3?'bg-blue-700':'bg-gray-400'" @click="clickTitle(3)">スタッフごと</div>
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==2?'bg-blue-700':'bg-gray-400'" @click="clickTitle(2)">物件ごと</div>
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==1?'bg-blue-700':'bg-gray-400'" @click="clickTitle(1)">スポット変更</div>
            <div class="w-28 rounded py-1 text-center cursor-pointer" :class="filter.title==4?'bg-blue-700':'bg-gray-400'" @click="clickTitle(4)">実績一覧</div>
          </div>

          <PrimaryButton
            text="検索"
            :buttonContents="'要'"
            class="mx-2 w-32"
            @click="getData(1)"
          >
          </PrimaryButton>

          <div class="text-lg font-bold text-white text-right">
            <p v-if="[0,1,3].includes(filter.title)">{{ list.length }} <span v-if="filter.title">件</span><span v-else>人</span></p>
            <p v-else>{{ records }} 件</p>
          </div>

          <Icon
            iconName="Refresh"
            :clickable="false"
            :class="{'animate-spin': loading}"
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="refresh"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="flex justify-between">
          <div v-if="[0, 3].includes(filter.title)" class="flex-1 text-white text-xs font-bold whitespace-nowrap w-fit mt-auto mb-1">※物件名クリックで担当者臨時変更</div>
          <div v-else class="flex-1"></div>

          <!-- 表示非表示 -->
          <div v-if="[0, 3].includes(filter.title)" class="mr-2 w-fit flex whitespace-nowrap text-sm font-bold self-center">
            <div class="mx-2">
              <input type="checkbox" id="notDone" v-model="filter.notDone">
              <label for="notDone" class="p-1 text-white">未完了 物件</label>
            </div>
            <div class="mx-2">
              <input type="checkbox" id="done" v-model="filter.done">
              <label for="done" class="p-1 text-white">完了 物件</label>
            </div>
          </div>

          <div class="flex flex-1 justify-end">
            <!-- 1日前ボタン -->
            <Icon
              v-if="[0,1].includes(filter.title)"
              iconName="ChevronLeft"
              :clickable="false"
              class="text-white hover:text-yellow-400 cursor-pointer w-10 h-8 self-center"
              @click.native="clickChevron(-1)"
            />

            <!-- 日付 -->
            <div v-if="[0, 1, 3].includes(filter.title)">
              <WmsDateInput
                v-model="filter.startDate"
                class="date -mt-1 w-28 font-bold"
              />
            </div>

            <div v-if="filter.title==3" class="text-white font-bold text-lg mx-2 self-center">～</div>

            <!-- 終了日付 -->
            <div v-if="filter.title==3" class="mr-2">
              <WmsDateInput
                v-model="filter.endDate"
                class="date -mt-1 w-28 font-bold"
              />
            </div>

            <!-- 翌日ボタン -->
            <Icon
              v-if="[0,1].includes(filter.title)"
              iconName="ChevronRight"
              :clickable="false"
              class="text-white hover:text-yellow-400 cursor-pointer w-10 h-8 self-center"
              @click.native="clickChevron(1)"
            />

            <!-- 開始日 -->
            <div v-if="filter.title==4">
              <WmsDateInput
                name="resultStart"
                placeholder="日付"
                v-model="filter.resultStart"
                class="date -mt-1 w-28 font-bold"
              />
            </div>

            <div v-if="filter.title==4" class="text-white font-bold text-lg mx-2 self-center">～</div>

            <!-- 終了日 -->
            <div v-if="filter.title==4" class="mr-2">
              <WmsDateInput
                name="resultEnd"
                placeholder="日付"
                v-model="filter.resultEnd"
                class="date -mt-1 w-28 font-bold"
              />
            </div>

            <!-- 物件名 -->
            <div class="mr-2">
              <input
                type="search"
                name="filterSite"
                placeholder="物件名 検索"
                class="border border-gray-300 rounded leading-5 font-bold text-sm"
                v-model="filter.site"
              />
            </div>

            <!-- 物件住所 -->
            <div v-if="[0, 1, 2, 3].includes(filter.title)" class="mr-2">
              <input
                type="search"
                placeholder="物件住所 検索"
                class="border border-gray-300 rounded leading-5 font-bold text-sm w-36"
                v-model="filter.address"
              />
            </div>

            <!-- 担当者 -->
            <div class="mr-2">
              <WmsSuggestInput
                v-if="[0, 1, 3].includes(filter.title)"
                :selectionItems="staffList"
                displayField="userName"
                :embed="true"
                :clearable="true"
                placeholder="スタッフ 検索"
                class="staff-filter"
                v-model="filter.staff"
              >
              </WmsSuggestInput>
            </div>

            <div v-if="filter.title==1">
              <select
                v-model="filter.isChanged"
                class="border-gray-300 rounded py-1.5 text-black font-bold"
              >
                <option
                  v-for="(o, i) in [{ name: '全て', value: 0 }, { name: '変更済', value: 1 }, { name: '未変更', value: 2 }]" :key="'s' + i"
                  :value="o.value">
                  {{ o.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-24 w-screen bottom-4 mt-5 min-w-1215">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">

          <div v-if="loading" class="w-full h-full flex justify-center items-center">
            <p class="text-gray-400 font-bold animate-pulse">Searching...</p>
          </div>

          <div v-else-if="!loading && (!list || !list.length) && ![0, 3].includes(filter.title)" class="w-full h-full flex justify-center items-center">
            <p class="text-gray-400 font-bold">対象データがありません。検索条件をご確認ください。</p>
          </div>


          <!-- ************************************************** -->
          <!-- ********************* 進捗 *********************** -->
          <!-- ************************************************** -->
          <div v-if="filter.title==0" class="rounded h-full flex justify-between">
            <!-- スタッフ絞り込み -->
            <div class="h-full border-2 border-teal-500 text-white font-bold flex">
              <div v-if="filter.openBar" class="h-full overflow-y-auto overflow-x-hidden py-2 text-xs">
                <div class="flex justify-between">
                  <!-- クリア -->
                  <div class="border-b-2 border-indigo-700 text-indigo-700 m-3 px-2 w-fit cursor-pointer text-base font-extrabold self-baseline" @click="clickClear()">クリア</div>

                  <PrimaryButton
                    text="検索"
                    :buttonContents="'要'"
                    class="m-3 w-1/2"
                    @click="getData(1)"
                  >
                  </PrimaryButton>
                </div>

                <div v-if="group>1" class="flex">
                  <!-- 直属の部下 -->
                  <div class="flex-1 text-center border-b-2 border-indigo-700 text-indigo-700 m-3 w-fit cursor-pointer text-base font-extrabold whitespace-nowrap" @click="clickJunior()">直属の部下</div>
                  <!-- 部下全員 -->
                  <div v-if="group>2" class="flex-1 text-center border-b-2 border-indigo-700 text-indigo-700 m-3 w-fit cursor-pointer text-base font-extrabold whitespace-nowrap" @click="clickJunior('all')">部下全員</div>
                </div>

                <!-- 全員 -->
                <div class="rounded m-2 px-3 py-2 whitespace-nowrap border border-teal-500 text-center cursor-pointer" :class="filter.allStaff?'bg-teal-600':'bg-gray-500'" @click="clickAllStaff()">全員表示</div>

                <div class="staff-grid mx-2">
                  <div  class="rounded px-2 py-1 cursor-pointer" :class="filter.allStaff||filter.staffList.includes(null)?'bg-teal-600':'bg-gray-500'" @click="clickStaff(null)">未定</div>
                  <div v-for="(s, i) in staffList" :key="'staffs'+i" class="rounded px-2 py-1 whitespace-nowrap cursor-pointer" :class="[filter.allStaff||filter.staffList.includes(s.userId)?'bg-teal-600':'bg-gray-500', s.userId==userId?'border-2 border-yellow-500':'']" @click="clickStaff(s.userId)">
                    {{ s.userName }}
                  </div>
                </div>
              </div>
              <!-- 開閉バー -->
              <div class="h-full border-teal-500 bg-teal-500 text-white px-1.5 py-10 font-bold bar cursor-pointer" @click="clickBar()">
                <div v-if="filter.openBar">
                  スタッフ 検索 &#12288; ◀ ◀ ◀
                </div>
                <div v-else>
                  スタッフ 検索 &#12288; ▶ ▶ ▶
                </div>
              </div>
            </div>

            <!-- 進捗 -->
            <div v-if="list&&list.length" class="mr-auto flex flex-wrap text-xs overflow-auto">
              <div v-for="(row, i) in list" :key="'li'+i" class="border-2 border-gray-400 rounded p-2 box-border flex-1" :class="!row.trash.length&&!row.clean.length?'bg-blue-50':''">
                <!-- 名前 -->
                <div class="p-1 flex justify-between font-bold text-sm bg-blue-200 text-blue-800 text-center whitespace-nowrap cursor-pointer" @click="openStaffMapLastDone(row.staffId, row.staff)">
                  <div class="flex-1"></div>
                  <div class="flex-1">{{ row.staff }}</div>
                  <div v-if="row.staff!='未定'" class="flex-1 text-right pl-2">
                    <span class="rounded bg-teal-50 text-teal-800 border-teal-500 py-1 px-2 text-xs">地図</span>
                  </div>
                  <div v-else class="flex-1"></div>
                </div>

                <!-- TOTAL -->
                <div v-if="filter.done" class="p-1 font-bold text-sm bg-blue-100 text-gray-700 text-center whitespace-nowrap">
                  <span class="pr-3">合計</span>
                  <span class="pr-3">ゴミ：{{ row.trash?row.trash.length:'-' }}</span>
                  <span>清掃：{{ row.clean?row.clean.length:'-' }}</span>
                </div>
                <!-- 残りの件数 -->
                <div v-if="filter.notDone&&(row.trashNot||row.cleanNot)" class="p-1 font-bold text-sm bg-red-700 text-white text-center whitespace-nowrap">
                  <span class="pr-3">残数</span>
                  <span class="pr-3">ゴミ：{{ row.trashNot }}</span>
                  <span>清掃：{{ row.cleanNot }}</span>
                </div>
                <div v-else-if="filter.notDone" class="h-7"></div>

                <div class="flex mt-2 justify-center">
                  <div v-if="row.trash&&row.trash.length" class="whitespace-nowrap mr-1">
                    <div class="font-bold text-green-700 text-center">ゴミ</div>
                    <div v-for="(r, k) in row.trash" :key="i+'tr'+k">
                      <!-- ゴミ完了 -->
                      <div v-if="r.time" class="rounded text-green-800 border border-green-800 mb-1 px-0.5 font-bold">
                        <span>{{ r.time }}</span>：{{ r.site }}
                        <div v-if="r.gps" class="text-red-700">{{ r.gps }}</div>
                        <div v-if="r.spot" class="text-teal-500 font-normal ml-2">スポット</div>
                      </div>

                      <!-- ゴミ未完了 -->
                      <div v-else class="rounded text-white font-bold bg-green-700 mb-1 px-0.5 cursor-pointer" :class="r.clickSite?'mb-3':''">
                        <div @click="clickSite(r)">{{ r.site }}</div>

                        <div v-if="r.clickSite" class="pb-1">
                          <div v-if="r.address" class="text-xs mt-1.5 text-gray-800 bg-green-200 px-1">{{ r.address }}</div>
                          <div class="py-1 flex justify-between">
                            <WmsSuggestInput
                              placeholder="臨時変更"
                              :selectionItems="staffList"
                              displayField="userName"
                              :embed="true"
                              :clearable="true"
                              class="w-32 staff1"
                              v-model="r.trashChangeStaff"
                              @selected="getStaffId(r, 'trashChangeStaffId', $event)"
                            >
                            </WmsSuggestInput>
                            <div @click="staffSelectedByProgress(row, r, 'trash')" class="ml-1 whitespace-nowrap text-xs text-green-800 font-bold py-2 px-2 bg-green-50 rounded">決定</div>
                          </div>
                          <div class="text-xs px-1 border-b w-fit text-gray-100 border-gray-100"  @click="openCalendar(r)">カレンダー</div>
                        </div>
                        <div v-if="r.spot" class="text-teal-200 font-normal ml-2">スポット</div>
                      </div>
                    </div>
                  </div>

                  <div v-if="row.clean&&row.clean.length" class="whitespace-nowrap ml-1">
                    <div class="font-bold text-blue-700 text-center">清掃</div>
                    <div v-for="(r, k) in row.clean" :key="i+'cl'+k">
                      <!-- 清掃完了 -->
                      <div v-if="r.time" class="rounded text-blue-800 border border-blue-800 mb-1 px-0.5 font-bold">
                        <span>{{ r.time }}</span>：{{ r.site }}

                        <!-- 報告書 -->
                        <div class="text-yellow-700 font-bold pb-0.5">
                          <div v-if="r.report"><Icon iconName="CheckCircle" class="text-yellow-600 inline-block h-4 w-4" /> 報告書完了</div>
                          <div v-else-if="r.is_report">● 報告書</div>
                          <div v-if="r.mc||r.sc">（当月 通常 {{ r.mc || 0 }}回{{ r.sc ? '、特別仕様 ' + r.sc + '回' : '' }} 報告書作成済み）</div>
                        </div>

                        <div v-if="r.gps" class="text-red-700">{{ r.gps }}</div>
                        <div class="text-blue-600 ml-2">
                          <span v-if="r.exchange">{{ r.exchange }}の振替</span>
                          <span v-if="r.spot">スポット</span>
                        </div>
                      </div>

                      <!-- 清掃未完了 -->
                      <div v-else class="rounded text-white font-bold bg-blue-800 mb-1 px-0.5 cursor-pointer" :class="r.clickSite?'mb-3':''">
                        <div @click="clickSite(r)">{{ r.site }}</div>

                        <div v-if="r.clickSite" class="pb-1">
                          <div v-if="r.clickSite&&r.address" class="text-xs mt-1.5 text-gray-800 bg-blue-200 px-1">{{ r.address }}</div>
                          <div v-if="r.clickSite" class="py-1 flex justify-between">
                            <WmsSuggestInput
                              placeholder="臨時変更"
                              :selectionItems="staffList"
                              displayField="userName"
                              :embed="true"
                              :clearable="true"
                              class="w-32 staff1"
                              v-model="r.cleanChangeStaff"
                              @selected="getStaffId(r, 'cleanChangeStaffId', $event)"
                            >
                            </WmsSuggestInput>
                            <div @click="staffSelectedByProgress(row, r, 'clean')" class="ml-1 whitespace-nowrap text-xs text-blue-800 font-bold py-2 px-2 bg-blue-50 rounded">決定</div>
                          </div>

                          <div class="text-xs px-1 border-b w-fit text-gray-100 border-gray-100"  @click="openCalendar(r)">カレンダー</div>
                        </div>

                        <!-- 報告書 -->
                        <div class="text-yellow-300 font-bold pb-1">
                          <div v-if="r.report"><Icon iconName="CheckCircle" class="inline-block h-4 w-4" />報告書完了</div>
                          <div v-else-if="r.is_report">● 報告書</div>
                          <div v-if="r.mc||r.sc">（当月 通常 {{ r.mc || 0 }}回{{ r.sc ? '、特別仕様 ' + r.sc + '回' : '' }} 報告書作成済み）</div>
                        </div>

                        <div class="text-light-blue-100 font-normal ml-2">
                          <span v-if="r.exchange">{{ r.exchange }}の振替</span>
                          <span v-if="r.spot">スポット</span>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="!loading && (!list || !list.length)" class="w-full h-full flex justify-center items-center text-gray-400 font-bold">
              <div>
                <p class="">対象データがありません。検索条件をご確認ください。</p>
                <p v-if="!filter.allStaff&&!filter.staffList.length" class="text-red-700">左側の「スタッフ検索」にて「全員表示」もしくはスタッフを選択してください。</p>
                <p v-if="!filter.notDone&&!filter.done" class="text-red-700">「未完了 物件」か「完了 物件」かどちらかONにしてください。</p>
              </div>
            </div>

            <!-- MAP -->
            <div v-if="staffMap" class="map-size sticky top-0 self-start float-right">
              <RlsMapComponent
                :list="mapData"
              />

              <div class="text-sm text-gray-700 font-bold my-2 text-center whitespace-pre-line">{{ info }}</div>

              <SecondaryButton
                text="閉じる"
                class="mx-auto w-fit block my-1 px-5 border-gray-500 border"
                @click="mapClosed()"
              >
              </SecondaryButton>
            </div>
            <div class="text-transparent text-xs">{{reload}}</div>
          </div>

          <!-- ************************************************** -->
          <!-- ****************** 担当者変更 ********************* -->
          <!-- ************************************************** -->
          <div v-else-if="filter.title==1" class="rounded h-full">
            <table class="w-full overflow-auto ">
              <thead class="sticky top-0 z-5 bg-colu text-xs text-gray-700">
                <tr>
                  <th v-for="(c, i) in columns1" :key="'col'+i" class="p-2 text-gray-800" :class="c.class">
                    <div v-if="c.key=='check1'" class="rounded bg-indigo-600 text-white cursor-pointer p-1 w-fit whitespace-nowrap mx-auto" @click="changeAll(c.id)">
                      ✅ ゴミ担当者
                      <p>{{ filter.staff?`「${filter.staff}」のみ`:'' }}全選択</p>
                    </div>
                    <div v-else-if="c.key=='check2'" class="rounded bg-indigo-600 text-white cursor-pointer p-1 w-fit whitespace-nowrap mx-auto" @click="changeAll(c.id)">
                      ✅ 清掃担当者
                      <p>{{ filter.staff?`「${filter.staff}」のみ`:'' }}全選択</p>
                    </div>
                    <div v-else>
                      {{ c.val }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr class="border-b border-gray-400">
                  <td></td>
                  <td></td>
                  <td class="text-xs font-bold text-gray-700 border-l border-gray-400 p-1.5 w-fit whitespace-nowrap min-w-min text-center">担当を一括変更</td>
                  <td class="text-center p-1 ">
                    <div class="text-xs text-gray-700 p-1">担当者を選び、決定ボタンを押してください<br>チェックがついたものを一括変更します</div>
                    <div class="flex whitespace-nowrap justify-center">
                      <WmsSuggestInput
                        :selectionItems="staffList"
                        displayField="userName"
                        :embed="true"
                        :clearable="true"
                        class="w-32 staff"
                        v-model="allChangeStaffTrash"
                      >
                      </WmsSuggestInput>

                      <div class="text-xs font-bold self-center text-gray-700 ml-1 mr-2">に変更</div>

                      <PrimaryButton text="決定" size="sm" class="px-1 bg-blue-100 text-blue-700 border-blue-700" @click="clickChangeStaff('Trash')" :disabled="loading"></PrimaryButton>
                    </div>
                  </td>
                  <td class="text-xs font-bold text-gray-700 border-l border-gray-400 p-1.5 w-fit whitespace-nowrap min-w-min text-center">担当を一括変更</td>
                  <td class="text-center p-1 ">
                    <div class="text-xs text-gray-700 p-1">担当者を選び、決定ボタンを押してください<br>チェックがついたものを一括変更します</div>
                    <div class="flex whitespace-nowrap justify-center">
                      <WmsSuggestInput
                        :selectionItems="staffList"
                        displayField="userName"
                        :embed="true"
                        :clearable="true"
                        class="w-32 staff"
                        v-model="allChangeStaffClean"
                      >
                      </WmsSuggestInput>

                      <div class="text-xs font-bold self-center text-gray-700 ml-1 mr-2">に変更</div>

                      <PrimaryButton text="決定" size="sm" class="px-1 bg-blue-100 text-blue-700 border-blue-700" @click="clickChangeStaff('Clean')" :disabled="loading"></PrimaryButton>
                    </div>
                  </td>
                </tr>
                <tr v-for="(row, i) in list" :key="'lit'+i" class="border-b border-gray-400 hover-color">
                  <!-- 物件 -->
                  <td class="cursor-pointer font-bold whitespace-nowrap w-fit">
                    <div class="border-b text-blue-700 border-blue-700 w-fit m-2" @click="edit(row)">{{ row.site }}</div>
                    <div class="p-2 text-gray-700 font-normal">{{ row.address }}</div>
                  </td>

                  <!-- カレンダー -->
                  <td class="p-2 text-gray-700 font-bold whitespace-nowrap text-xs cursor-pointer" @click="openCalendar(row)">
                    <div class="border-b border-gray-700 w-fit">カレンダー</div>
                  </td>

                  <!-- 変更チェック -->
                  <td class="p-2 text-center border-l border-gray-400">
                    <input v-if="row.isTrash&&!row.trashDoneTime" type="checkbox" class="p-2" v-model="row.changeTrash">
                  </td>

                  <!-- ゴミ担当 -->
                  <td class="p-2 text-center whitespace-nowrap">
                    <!-- なし -->
                    <div v-if="!row.isTrash">--</div>
                    <!-- あり -->
                    <WmsSuggestInput
                      v-else-if="!row.trashDoneTime"
                      :selectionItems="staffList"
                      displayField="userName"
                      :embed="true"
                      :clearable="true"
                      v-model="row.trashStaff"
                      @selected="staffSelected(row, 'trash', $event)"
                      class="w-fit mx-auto staff"
                    >
                    </WmsSuggestInput>
                    <div v-else-if="row.trashDoneTime" class="text-xs font-bold text-gray-600">完了済</div>
                    <div v-if="row.isChangedTrash&&!row.trashDoneTime" class="text-red-700 font-bold text-xs">変更済み</div>
                  </td>

                  <!-- 変更チェック -->
                  <td class="text-center w-fit border-l border-gray-400">
                    <input v-if="row.isClean&&!row.cleanDoneTime" type="checkbox" class="p-2" v-model="row.changeClean">
                  </td>

                  <!-- 清掃担当 -->
                  <td class="p-2 text-center whitespace-nowrap">
                    <div class="text-light-blue-500 text-sm" v-if="row.exchange">{{ row.exchange }}の振替</div>
                    <!-- なし -->
                    <div v-if="!row.isClean">--</div>
                    <!-- あり -->
                    <WmsSuggestInput
                      v-else-if="!row.cleanDoneTime"
                      :selectionItems="staffList"
                      displayField="userName"
                      :embed="true"
                      :clearable="true"
                      v-model="row.cleanStaff"
                      @selected="staffSelected(row, 'clean', $event)"
                      class="w-fit mx-auto staff"
                    >
                    </WmsSuggestInput>
                    <div v-else-if="row.cleanDoneTime" class="text-xs font-bold text-gray-600">完了済</div>
                    <div v-if="row.isChangedClean&&!row.cleanDoneTime" class="text-red-700 font-bold text-xs">変更済み</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-transparent text-xs">{{reload}}</div>
          </div>

          <!-- ************************************************** -->
          <!-- ******************** 物件軸 *********************** -->
          <!-- ************************************************** -->
          <div v-else-if="filter.title==2" class="rounded">
            <table class="w-full overflow-auto main">
              <thead class="sticky top-0 z-20 bg-colu text-xs text-gray-700">
                <tr>
                  <th v-for="(c, i) in columns2" :key="'col'+i" class="p-2 text-gray-800" :class="c.class">
                    {{ c.val }}
                  </th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="(row, i) in list" :key="'lit'+i" class="border-b border-gray-400 hover-color">
                  <!-- 物件 -->
                  <td class="cursor-pointer font-bold whitespace-nowrap w-fit">
                    <div class="border-b text-blue-700 border-blue-700 w-fit m-2" @click="edit(row)">{{ row.site }}</div>
                    <p class="text-xs text-gray-700 mt-1">{{ row.client }}</p>
                  </td>

                  <!-- 住所 -->
                  <td class="cursor-pointer text-xs whitespace-nowrap w-fit p-2">
                    <p>{{ row.address1 }}</p>
                    <p>{{ row.address2 }}</p>
                  </td>

                  <!-- カレンダー -->
                  <td class="p-2 text-gray-700 font-bold whitespace-pre-wrap text-xs cursor-pointer" @click="openCalendar(row)">
                    <div class="border-b border-gray-700 w-fit">カレンダー</div>
                  </td>

                  <!-- 物件概要書 -->
                  <td class="p-1 text-center"  @click="openOutline(row.site_code)">
                    <div class="text-xs font-bold text-white whitespace-nowrap py-1 px-2 bg-yellow-600 cursor-pointer">概要書</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!loading" class="my-3 w-fit mx-auto">
              <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData()" />
            </div>
            <div class="text-transparent text-xs">{{reload}}</div>
          </div>

          <!-- ************************************************** -->
          <!-- ****************** スタッフ軸 ********************* -->
          <!-- ************************************************** -->
          <div v-else-if="filter.title==3" class="rounded h-full w-full overflow-hidden ">

              <!-- 一覧 -->
              <div class="w-full flex max-table">
                <!-- スタッフ絞り込み -->
                <div class="h-full border-2 border-teal-500 text-white font-bold flex">
                  <div v-if="filter.openBar" class="h-full overflow-y-auto overflow-x-hidden py-2 text-xs">
                    <div class="flex justify-between">
                      <!-- クリア -->
                      <div class="border-b-2 border-indigo-700 text-indigo-700 m-3 px-2 w-fit cursor-pointer text-base font-extrabold self-baseline" @click="clickClear()">クリア</div>

                      <PrimaryButton
                        text="検索"
                        :buttonContents="'要'"
                        class="m-3 w-1/2"
                        @click="getData(1)"
                      >
                      </PrimaryButton>
                    </div>

                    <div v-if="group>1" class="flex">
                      <!-- 直属の部下 -->
                      <div class="flex-1 text-center border-b-2 border-indigo-700 text-indigo-700 m-3 w-fit cursor-pointer text-base font-extrabold whitespace-nowrap" @click="clickJunior()">直属の部下</div>
                      <!-- 部下全員 -->
                      <div v-if="group>2" class="flex-1 text-center border-b-2 border-indigo-700 text-indigo-700 m-3 w-fit cursor-pointer text-base font-extrabold whitespace-nowrap" @click="clickJunior('all')">部下全員</div>
                    </div>

                    <!-- 部下全員 -->
                    <div class="rounded m-2 px-3 py-2 whitespace-nowrap border border-teal-500 text-center cursor-pointer" :class="filter.allStaff?'bg-teal-600':'bg-gray-500'" @click="clickAllStaff()">全員表示</div>

                    <div class="staff-grid mx-2">
                      <div  class="rounded px-2 py-1 cursor-pointer" :class="filter.allStaff||filter.staffList.includes(null)?'bg-teal-600':'bg-gray-500'" @click="clickStaff(null)">未定</div>
                      <div v-for="(s, i) in staffList" :key="'staffs'+i" class="rounded px-2 py-1 whitespace-nowrap cursor-pointer" :class="[filter.allStaff||filter.staffList.includes(s.userId)?'bg-teal-600':'bg-gray-500', s.userId==userId?'border-2 border-yellow-500':'']" @click="clickStaff(s.userId)">
                        {{ s.userName }}
                      </div>
                    </div>
                  </div>
                  <!-- 開閉バー -->
                  <div class="h-full border-teal-500 bg-teal-500 text-white px-1.5 py-10 font-bold bar cursor-pointer" @click="clickBar()">
                    <div v-if="filter.openBar">
                      スタッフ 検索 &#12288; ◀ ◀ ◀
                    </div>
                    <div v-else>
                      スタッフ 検索 &#12288; ▶ ▶ ▶
                    </div>
                  </div>
                </div>
                <div v-if="list&&list.length" class="h-full w-full overflow-auto border">
                  <table class="w-full overflow-auto border-separate space-x-4 space-y-3">
                    <thead class="sticky top-0 bg-colu text-xs text-gray-700 z-1">
                      <tr>
                        <th v-for="(c, i) in columns3" :key="'col'+i" class="p-2 text-gray-800 whitespace-nowrap">
                          {{ c.val }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="text-sm">
                      <tr v-for="(row, i) in list" :key="'lit'+i" class="">

                        <td v-for="(row2, j) in columns3" :key="i+'r'+j" class="p-2 border-r border-b border-gray-400" :class="j?'align-top':'border-separate sticky left-0 bg-white'">
                          <!-- スタッフ -->
                          <div v-if="!j" class="font-bold text-gray-700 whitespace-nowrap w-fit">{{ row.staff }}</div>

                          <!-- 日にちごと -->
                          <div v-else-if="row.days&&row.days[row2.key]">
                            <!-- TOTAL -->
                            <div class="p-1 font-bold text-sm bg-blue-100 text-gray-700 text-center whitespace-nowrap">
                              <span v-if="row.days[row2.key].trash" class="pr-3">ゴミ：{{ row.days[row2.key].trash.length }}</span>
                              <span v-if="row.days[row2.key].clean">清掃：{{ row.days[row2.key].clean.length }}</span>
                            </div>

                            <!-- 詳細 -->
                            <div class="flex mt-2 text-xs justify-center">
                              <div v-if="row.days[row2.key].trash&&row.days[row2.key].trash.length" class="whitespace-nowrap mr-1">
                                <div class="font-bold text-green-700 text-center">ゴミ</div>
                                <!-- ゴミ -->
                                <div v-for="(r, k) in row.days[row2.key].trash" :key="i+'tr'+j+'tr'+k">
                                  <!-- ゴミ完了 -->
                                  <div v-if="r.time" class="rounded text-green-800 border border-green-800 mb-1 px-0.5 font-bold">
                                    <span class="">{{ r.time }}</span>：{{ r.site }}
                                    <div v-if="r.gps" class="text-red-700">{{ r.gps }}</div>
                                    <div v-if="r.spot" class="text-teal-500 ml-2">スポット</div>
                                  </div>

                                  <!-- ゴミ未完了 -->
                                  <div v-else class="rounded text-white font-bold bg-green-700 mb-1 px-0.5 cursor-pointer" :class="r.clickSite?'mb-3':''">
                                    <div @click="clickSite(r)">{{ r.site }}</div>

                                    <div v-if="r.clickSite" class="pb-1">
                                      <div v-if="r.address" class="text-xs mt-1.5 text-gray-800 bg-green-200 px-1">{{ r.address }}</div>
                                      <div class="py-1 flex justify-between">
                                        <WmsSuggestInput
                                          placeholder="臨時変更"
                                          :selectionItems="staffList"
                                          displayField="userName"
                                          :embed="true"
                                          :clearable="true"
                                          class="w-32 staff1"
                                          v-model="r.trashChangeStaff"
                                          @selected="getStaffId(r, 'trashChangeStaffId', $event)"
                                        >
                                        </WmsSuggestInput>
                                        <div @click="staffSelectedByProgress(row, r, 'trash', row2.key)" class="ml-1 whitespace-nowrap text-xs text-green-800 font-bold py-2 px-2 bg-green-50 rounded">決定</div>
                                      </div>
                                      <div class="text-xs px-1 border-b w-fit text-gray-100 border-gray-100"  @click="openCalendar(r)">カレンダー</div>
                                    </div>
                                    <div v-if="r.spot" class="text-teal-200 ml-2">スポット</div>
                                  </div>
                                </div>
                              </div>

                              <div v-if="row.days[row2.key].clean&&row.days[row2.key].clean.length" class="whitespace-nowrap ml-1">
                                <div class="font-bold text-blue-700 text-center">清掃</div>
                                <!-- 清掃未完了 -->
                                <div v-for="(r, k) in row.days[row2.key].clean" :key="i+'cl'+j+'cl'+k">
                                  <!-- 清掃完了 -->
                                  <div v-if="r.time" class="rounded text-blue-800 border border-blue-800 mb-1 px-0.5 font-bold">
                                    <span>{{ r.time }}</span>：{{ r.site }}

                                    <!-- 報告書 -->
                                    <div class="text-yellow-700 font-bold pb-0.5">
                                      <div v-if="r.report"><Icon iconName="CheckCircle" class="text-yellow-600 inline-block h-4 w-4" />報告書完了</div>
                                      <div v-else-if="r.is_report">● 報告書</div>
                                      <div v-if="r.mc||r.sc">（当月 通常 {{ r.mc || 0 }}回{{ r.sc ? '、特別仕様 ' + r.sc + '回' : '' }} 報告書作成済み）</div>
                                    </div>

                                    <div v-if="r.gps" class="text-red-700">{{ r.gps }}</div>
                                    <div class="text-blue-600 ml-2">
                                      <span v-if="r.exchange">{{ r.exchange }}の振替</span>
                                      <span v-if="r.spot">スポット</span>
                                    </div>
                                  </div>

                                  <!-- 清掃未完了 -->
                                  <div v-else class="rounded text-white font-bold bg-blue-800 mb-1 px-0.5 cursor-pointer" :class="r.clickSite?'mb-3':''">
                                    <div @click="clickSite(r)">{{ r.site }}</div>

                                    <div v-if="r.clickSite" class="pb-1">
                                      <div v-if="r.clickSite&&r.address" class="text-xs mt-1.5 text-gray-800 bg-blue-200 px-1">{{ r.address }}</div>
                                      <div v-if="r.clickSite" class="py-1 flex justify-between">
                                        <WmsSuggestInput
                                          placeholder="臨時変更"
                                          :selectionItems="staffList"
                                          displayField="userName"
                                          :embed="true"
                                          :clearable="true"
                                          class="w-32 staff1"
                                          v-model="r.cleanChangeStaff"
                                          @selected="getStaffId(r, 'cleanChangeStaffId', $event)"
                                        >
                                        </WmsSuggestInput>
                                        <div @click="staffSelectedByProgress(row, r, 'clean', row2.key)" class="ml-1 whitespace-nowrap text-xs text-blue-800 font-bold py-2 px-2 bg-blue-50 rounded">決定</div>
                                      </div>

                                      <div class="text-xs px-1 border-b w-fit text-gray-100 border-gray-100"  @click="openCalendar(r)">カレンダー</div>
                                    </div>

                                    <!-- 報告書 -->
                                    <div class="text-yellow-300 font-bold pb-1">
                                      <div v-if="r.report"><Icon iconName="CheckCircle" class="text-yellow-300 inline-block h-4 w-4" />報告書完了</div>
                                      <div v-else-if="r.is_report">● 報告書</div>
                                      <div v-if="r.mc||r.sc">（当月 通常 {{ r.mc || 0 }}回{{ r.sc ? '、特別仕様 ' + r.sc + '回' : '' }} 報告書作成済み）</div>
                                    </div>

                                    <div class="text-light-blue-100 font-normal ml-2">
                                      <span v-if="r.exchange">{{ r.exchange }}の振替</span>
                                      <span v-if="r.spot">スポット</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else-if="!loading && (!list || !list.length)" class="w-full h-full flex justify-center items-center text-gray-400 font-bold">
                  <div>
                    <p class="">対象データがありません。検索条件をご確認ください。</p>
                    <p v-if="!filter.allStaff&&!filter.staffList.length" class="text-red-700">左側の「スタッフ検索」にて「全員表示」もしくはスタッフを選択してください。</p>
                    <p v-if="!filter.notDone&&!filter.done" class="text-red-700">「未完了 物件」か「完了 物件」かどちらかONにしてください。</p>
                    <p v-if="filter.startDate>filter.endDate" class="text-red-700">表示期間の日付が逆になっています。</p>
                  </div>
                </div>
              </div>

              <div class="text-transparent text-xss">{{reload}}</div>
              <div v-if="!loading" class="w-fit mx-auto">
                <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData()" />
              </div>

          </div>

          <!-- ************************************************** -->
          <!-- ******************* 実績一覧 ********************** -->
          <!-- ************************************************** -->
          <div v-else-if="filter.title==4" class="rounded h-full">
            <table class="w-full overflow-auto">
              <thead class="sticky top-0 z-5 bg-colu text-xs text-gray-700">
                <tr>
                  <th v-for="(c, i) in columns4" :key="'col'+i" class="p-2 text-gray-800" :class="c.class">
                    {{ c.val }}
                  </th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="(row, i) in list" :key="'lit'+i" class="border-b hover-color">
                  <!-- 物件 -->
                  <td class="p-2 text-blue-700 cursor-pointer font-bold whitespace-nowrap w-fit" @click="edit(row)">
                    <div class="border-b border-blue-700 w-fit">{{ row.site }}</div>
                    <!-- <p class="text-xs text-gray-900 pt-1">（{{ row.site_code }}）</p> -->
                  </td>

                  <!-- 得意先 -->
                  <!-- <td class="p-2 text-right whitespace-nowrap">
                    {{ row.client }}
                  </td> -->

                  <!-- ゴミ出し -->
                  <td class="p-2 text-left whitespace-nowrap">
                    {{ row.trash }}
                  </td>

                  <!-- ゴミ出し -->
                  <td class="p-2 text-left whitespace-nowrap">
                    <div v-if="row.trashGpsOk" class="text-blue-600">🔵 GPS問題なし：{{ row.trashGpsOk }}</div>
                    <div v-if="row.trashGpsOff">✖ GPS OFF：{{ row.trashGpsOff }}</div>
                    <div v-if="row.trashGpsSiteNg">▲ 物件住所相違：{{ row.trashGpsSiteNg }}</div>
                    <div v-if="row.trashGpsNg">✖ GPS違う：{{ row.trashGpsNg }}</div>
                    <div v-if="row.trashGpsForgt">✖ 押し忘れ：{{ row.trashGpsForget }}</div>
                  </td>

                  <!-- 清掃 -->
                  <td class="p-2 text-left whitespace-nowrap">
                    {{ row.clean }}
                  </td>

                  <!-- 清掃 -->
                  <td class="p-2 text-left whitespace-nowrap">
                    <div v-if="row.cleanGpsOk" class="text-blue-600">🔵 GPS問題なし：{{ row.cleanGpsOk }}</div>
                    <div v-if="row.cleanGpsOff">✖ GPS OFF：{{ row.cleanGpsOff }}</div>
                    <div v-if="row.cleanGpsSiteNg">▲ 物件住所相違：{{ row.cleanGpsSiteNg }}</div>
                    <div v-if="row.cleanGpsNg">✖ GPS違う：{{ row.cleanGpsNg }}</div>
                    <div v-if="row.cleanGpsForget">✖ 押し忘れ：{{ row.cleanGpsForget }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!loading" class="my-3 w-fit mx-auto">
              <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData()" />
            </div>
            <div class="text-transparent text-xs">{{reload}}</div>
          </div>
        </div>
      </div>
    </main>

    <!-- カレンダー -->
    <RlsCalendarModal
      v-model="siteCalendarOpen"
      :target="siteCalendar"
      :open="siteCalendarOpen"
      :operation="true"
      @closed="closed"
      @getData="getData"
    />
    <!-- マスタ編集モーダル -->
    <RlsMstEditModal
      v-model="modalOpen"
      :target="modalData"
      :staffList="staffList"
      :open="modalOpen"
      @closed="closed"
      @getData="getData"
    />
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import RlsMstEditModal from '../components/RlsMstEditModal.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import RlsMapComponent from '../components/RlsMapComponent.vue'
import RlsCalendarModal from '../components/RlsCalendarModal.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import Pagination from 'vue-pagination-2'
import * as backend from '@libs/backend'
import * as moment from 'moment'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'

import PageModel from '../../main/pages/PageModel.vue'

const SETTION_STRAGE_NMME = 'rlsOperation'

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    PrimaryButton,
    RlsMstEditModal,
    WmsSuggestInput,
    WmsDateInput,
    RlsMapComponent,
    RlsCalendarModal,
    SecondaryButton,
    Pagination
  },

  props: {
  },

  data() {
    return {
      loading: false,
      reload: 0,

      userId: Number(this.$store.getters.user.id),

      // 検索
      filter: {
        title: 0,
        site : '',
        address: '',
        staff: '',
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        resultStart: moment().format('YYYY-MM-01'),
        resultEnd: moment().endOf('month').format('YYYY-MM-DD'),
        // 未完了
        notDone: true,
        // 完了
        done: false,
        // 担当者変更
        isChanged: 0,
        // 検索欄開閉
        openBar: true,
        // 全員表示
        allStaff: false,
        // 担当者絞り込み
        staffList: [Number(this.$store.getters.user.id)]
      },
      // カラム 担当者変更
      columns1: [
        { key: 'site', val: '物件名（クリックでマスタ表示）', class: 'text-left' },
        { key: 'calendar', val: '', class: 'text-center' },
        { key: 'check1', id: 'trash', val: '', class: 'text-center' },
        { key: 'trashStaff', val: 'ゴミ出し', class: 'text-center whitespace-pre-line' },
        { key: 'check2', id: 'clean', val: '', class: 'text-center' },
        { key: 'trashStaff', val: '清掃', class: 'text-center whitespace-pre-line' },
      ],
      // カラム 物件ごと
      columns2: [
        { key: 'site', val: '物件名/得意先（クリックでマスタ表示）', class: 'text-left' },
        { key: 'address', val: '物件住所', class: 'text-left' },
        { key: '', val: '', class: 'text-center whitespace-pre-line' },
        { key: '', val: '', class: 'text-center whitespace-pre-line' }
      ],
      // カラムスタッフ
      columns3: [],
      // カラム 実績
      columns4: [
        { key: 'site', val: '物件名', class: 'text-left' },
        { key: 'tarsh', val: 'ゴミ出し回数', class: 'text-left' },
        { key: 'tarshGps', val: 'ゴミ出しGPS', class: 'text-left' },
        { key: 'clean', val: '清掃回数', class: 'text-left' },
        { key: 'cleanGps', val: '清掃GPS', class: 'text-left' },
      ],
      // 表示するデータ
      list: [],
      // 検索前のリスト
      allList: [],
      // スタッフの地図表示
      staffMap: false,
      // スタッフの地図に表示するデータ
      mapData: [],

      // 説明
      info: '',

      // 一括変更スタッフ
      allChangeStaffTrash: '',
      allChangeStaffClean: '',

      // 物件カレンダーモーダル
      siteCalendarOpen: false,
      siteCalendar: null,

      // マスタ編集モーダル
      modalOpen: false,
      modalData: null,

      // スタッフリスト
      staffList: [],
      // 直属の部下
      junior: [],
      // 部下全員
      allJunior: [],

      // ページ数
      page: 1,
      // １ページの最大件数
      perPage: 50,
      // 全件数
      records: 0,
    }
  },

  async created() {
    // 条件取得
    this.getCondition()
    // スタッフリスト
    await this.getStaff()
    // スタッフリストにあるユーザーIDのみにする
    if (this.filter.staffList.length) {
      this.filter.staffList = this.staffList
        .map(s => s.userId)
        .filter(id => this.filter.staffList.includes(id))
    }
    // データ取得
    await this.getData(1)
  },

  computed: {
    group() {
      let res = 0
      const g = this.$store.getters.loginUserData
      if (g && g.groupNum) {
        res = g.groupNum
      }
      return res
    }

  },

  methods: {
    /**
     * データ取得
     */
    async getData(num) {
      this.loading = true
      this.perPage = 50
      this.setSessionStorage()
      if (num) {
        this.page = num
      }
      // 進捗
      if (this.filter.title == 0) {
        if (!this.filter.allStaff && !this.filter.staffList.length) {
          this.list = []
          this.loading = false
          return
        }
        const res = await backend.postData('rls/getSchedule', { ...this.filter })
        if (res.data && res.data.data.length) {
          this.list = res.data.data
        } else {
          this.list = []
          if (res.data.data.noData) {
            alert('まだ予定が生成されていません。予定を確認したい場合は管理者権限を持っているユーザーにご連絡ください。\r\n（夜間に自動で4ヶ月先までの予定が保存されます）')
          }
        }

      // 担当者変更
      } else if (this.filter.title == 1) {
        const res = await backend.postData('rls/getSchedule', { ...this.filter })
        if (res.data && res.data.data.length) {
          this.list = res.data.data

        } else {
          this.list = []
          if (res.data.data.noData) {
            alert('まだ予定が生成されていません。予定を確認したい場合は管理者権限を持っているユーザーにご連絡ください。\r\n（夜間に自動で4ヶ月先までの予定が保存されます）')
          }
        }

      // 物件ごと
      } else if (this.filter.title == 2) {
        const res = await backend.searchData('rls/getRlsSite', { ...this.filter, perPage: this.perPage, page: this.page })
        if (res.data.data && res.data.data.length) {
          this.list = res.data.data
          this.records = Number(this.list[0].totalSize)
        } else {
          this.list = []
          this.records = 0
        }

      // スタッフごと
      } else if (this.filter.title == 3) {
        this.perPage = 10
        if (!this.filter.allStaff && !this.filter.staffList.length) {
          this.list = []
          this.loading = false
          return
        }
        if (this.filter.startDate > this.filter.endDate) {
          this.list = []
          this.records = 0
          this.loading = false
          return
        }
        // カラム生成
        this.columns3 = []
        this.columns3.push({ key: 'staff', val: '名前', class: 'text-left' })

        const weekDays = ['日', '月', '火', '水', '木', '金', '土']

        let current = new Date(this.filter.startDate)
        const end = new Date(this.filter.endDate)

        while (current <= end) {
          const y = current.getFullYear()
          const m = String(current.getMonth() + 1).padStart(2, '0')
          const d = String(current.getDate()).padStart(2, '0')
          const w = weekDays[current.getDay()]

          const date = `${y}-${m}-${d}`
          const val = `${y}-${m}-${d}（${w}）`
          this.columns3.push({ key: date , val, date })

          // 翌日へ
          current.setDate(current.getDate() + 1)
        }

        const res = await backend.postData('rls/getSchedule', { ...this.filter, perPage: this.perPage, page: this.page })
        if (res.data.data && res.data.data.length) {
          this.list = res.data.data
          this.records = Number(this.list[0].totalSize)
        } else {
          this.list = []
          this.records = 0
          if (res.data.data.noData) {
            alert('まだ予定が生成されていません。予定を確認したい場合は管理者権限を持っているユーザーにご連絡ください。\r\n（夜間に自動で4ヶ月先までの予定が保存されます）')
          }
        }

      // 実施
      } else if (this.filter.title == 4) {
        if (!this.filter.resultStart) {
          await dialogs.showErrorDialog('表示開始日 未入力', '表示開始日を選択してください。')
          return
        }
        if (!this.filter.resultEnd) {
          await dialogs.showErrorDialog('表示終了日 未入力', '表示終了日を選択してください。')
          return
        }
        const start = moment(this.filter.resultStart + 'T00:00:00')
        const end = moment(this.filter.resultEnd + 'T00:00:00')
        if (start.isAfter(end)) {
          await dialogs.showErrorDialog('開始日が終了日より後の日付です', '開始日と終了日が逆になっています。')
          return
        }

        const res = await backend.searchData('rls/getResultList', { ...this.filter, perPage: this.perPage, page: this.page })
        if (res.data.data && res.data.data.length) {
          this.list = res.data.data
          this.records = Number(this.list[0].totalSize)
        } else {
          this.list = []
          this.records = 0
        }
      }
      this.loading = false
    },

    /**
     * 担当者検索欄バー開閉
     */
    clickBar() {
      this.filter.openBar = !this.filter.openBar
      this.reload++
    },

    /**
     * クリアボタン
     */
    clickClear() {
      this.filter.allStaff = false
      this.filter.staffList = []
      this.reload++
    },

    /**
     * 部下検索
     */
    async clickJunior(all) {
      if ((!all && this.junior && this.junior.length) || (all && this.allJunior && this.allJunior.length)) {
        if (all) {
          this.filter.staffList = utils.clone(this.allJunior)
        } else {
          this.filter.staffList = utils.clone(this.junior)
        }

      } else {
        const res = await backend.searchData('evaluation/getJunior', { all, userId: this.userId })
        if (res.data.data && res.data.data.length) {
          this.filter.staffList = res.data.data.map(row => row.userId)

          if (all) {
            this.allJunior = res.data.data.map(row => row.userId)
          } else {
            this.junior = res.data.data.map(row => row.userId)
          }
        }
      }

      this.filter.staffList.push(this.userId)
      this.reload++
    },

    /**
     * 全員表示
     */
    clickAllStaff() {
      this.filter.allStaff = !this.filter.allStaff
      // ONにした場合
      this.filter.staffList = this.staffList.map((s) => s.userId)
      this.filter.staffList.push(null)
      this.reload++
    },

    /**
     * スタッフ名クリック
     * @param userId ユーザーID
     */
    clickStaff(userId) {
      if (this.filter.staffList.includes(userId)) {
        this.filter.staffList = this.filter.staffList.filter((s) => {
          return s != userId
        })
        this.filter.allStaff = false

      } else {
        this.filter.staffList.push(userId)
      }
      this.reload++
    },

    /**
     * 切替
     */
    clickTitle(val) {
      if (this.filter.title != val) {
        this.list = []
        this.records = 0
        this.filter.title = val
        this.staffMap = false
        if (val == 0) {
          this.filter.staff = ''
        } else if (val == 1) {
          this.filter.staff = '未定'
        }
        this.getData(1)
      }
      this.reload++
    },

    /**
     * スタッフリスト取得
     */
    async getStaff() {
      const res = await backend.searchData('user/getByAuth', { auth: 'rls', departmentName: 'ラウンド', departmentName2: '品質管理', departmentName3: '建物管理' })
      if (res && res.data.data && res.data.data.length) {
        this.staffList = res.data.data.filter((d) => {
          return d.userName != '未定'
        })
      }
    },

    /**
     * 物件名クリックイベント
     */
    async clickSite(r) {
      // 完了済みは何もしない
      if (r.time) {
        return
      }
      if (r.clickSite) {
        r.clickSite = false
      } else {
        r.clickSite = true

        // 住所取得
        const res = await backend.searchData('rls/getSiteInfo', { siteCode: r.site_code })
        if (res.data.data) {
          r.address = res.data.data.address
        }
      }
      this.reload++
    },

    /**
     * 担当者変更全選択ボタン
     */
    changeAll(type) {
      let staff = utils.deleteSpace(this.filter.staff)
      if (type == 'trash') {
        this.list.forEach((row) => {
          if (row.isTrash && !row.trashDoneTime) {
            // 担当者検索あり
            if (staff) {
              if (row.trashStaff && utils.deleteSpace(row.trashStaff).indexOf(staff) > -1) {
                row.changeTrash = true
              }
            } else {
              row.changeTrash = true
            }
          }
        })
      } else {
        this.list.forEach((row) => {
          if (row.isClean && !row.cleanDoneTime) {
            // 担当者検索あり
            if (staff) {
              if (row.cleanStaff && utils.deleteSpace(row.cleanStaff).indexOf(staff) > -1) {
                row.changeClean = true
              }
            } else {
              row.changeClean = true
            }
          }
        })
      }
      this.reload++
    },

    /**
     * 一括変更イベント
     */
    async clickChangeStaff(type) {
      // 該当の種別でチェックがついているものを取得
      let target = []

      let lower = 'trash'
      let staff = this.allChangeStaffTrash
      if (type == 'Clean') {
        lower = 'clean'
        staff = this.allChangeStaffClean
      }
      const insertUser = this.$store.getters.user.id

      // スタッフが選択されているか確認
      if (!staff) {
        await dialogs.showErrorDialog('変更後の担当者未入力', '担当者を入力してください。')
        return
      }

      const staffCheck = this.staffList.find((s) => {
        return s.userName == staff
      })
      if (!staffCheck || (!staffCheck.userId && staffCheck.userId != 0)) {
        await dialogs.showErrorDialog('担当者をドロップダウンから選択してください', 'ユーザーIDが取得できませんでした。ユーザーをドロップダウンから選択後は手動で名前を変更しないようにお願いします。')
        return
      }

      for (let i = 0; i < this.list.length; i++) {
        const row = this.list[i]
        if (row['change' + type]) {
          target.push({
            staffId: staffCheck.userId,
            siteCode: row.siteCode || row.site_code,
            day: row.day,
            insertUser
          })
        }
      }

      if (!target || !target.length) {
        await dialogs.showErrorDialog('チェックなし', '1件もチェックが入っていません。')
        return
      }

      // 保存
      try {
        await backend.postData('rls/saveChangeStaffBulk', { list: target, type: lower })
      } catch (error) {
        alert('保存できませんでした。再度お願いします。')
      }

      // データ再取得
      await this.getData()
    },

    /**
     * スタッフID取得
     */
    getStaffId(r, key, e) {
      if (e.userId) {
        r[key] = e.userId
      }
    },

    /**
     * 進捗、スタッフごとから担当者変更
     */
    async staffSelectedByProgress(row, r, type, day) {
      if (!r[type + 'ChangeStaffId']) {
        const staff = this.staffList.find((s) => {
          return s.userName == r[type + 'ChangeStaff']
        })
        if (staff && staff.userId) {
          r[type + 'ChangeStaffId'] = staff.userId
        } else {
          await dialogs.showErrorDialog('スタッフのIDが取得できませんでした', 'ドロップダウンに表示されたスタッフのみ登録可能です。ドロップダウンから選択してください。')
          return
        }
      }

      let targetDay = ''
      if (!day) {
        targetDay = this.filter.startDate
      } else {
        targetDay = day
      }
      const userId = r[type + 'ChangeStaffId']
      const res = await this.staffSelected({ staffId: row.staffId, siteCode: r.site_code, day: targetDay }, type, { userId })
      // 保存成功
      if (res) {
        this.getData()
      }
    },

    /**
     * 担当者変更イベント
     */
    async staffSelected(row, type, e) {
      if (e.userId || e.userId == 0) {
        row.staffId = e.userId

        const saveData = {
          staffId: e.userId,
          siteCode: row.siteCode,
          day: row.day,
          type,
          insertUser: this.$store.getters.user.id
        }

        let flg = 'isChangedTrash'
        if (type == 'clean') {
          flg = 'isChangedClean'
        }

        // 保存
        try {
          await backend.postData('rls/saveChangeStaff', saveData)
          row[flg] = true
          return true
        } catch (error) {
          alert('保存できませんでした。再度お願いします。')
        }
      }
    },

    /**
     * 前日翌日アイコンイベント
     */
    clickChevron(add) {
      let day = this.filter.startDate
      if (day) {
        day += 'T00:00:00'
      }
      this.filter.startDate = moment(day).add(add, 'days').format('YYYY-MM-DD')

      // データ取得
      this.getData()
    },

    /**
     * スタッフが最後に完了した物件のMAP表示
     */
    async openStaffMapLastDone(staffId, name) {
      this.mapData = []
      this.info = ''

      if (name == '未定') {
        return
      }

      const res = await backend.searchData('rls/getResultByDay', { staffId, day: this.filter.startDate })
      if (res.data.data.length) {
        this.mapData = res.data.data
        this.info = `${this.filter.startDate}\r\n${name} さんが最後に完了した物件\r\n${this.mapData[0].address}\r\n${this.mapData[0].time}`
      }

      this.staffMap = true
    },

    /**
     * スタッフのMAP表示
     */
    openStaffMap(userId) {
      this.mapData = []

      if (userId) {
        this.mapData = this.allList.filter((row) => {
          return ((row.isTrash && row.trashStaffId == userId) || (row.isClean && row.cleanStaffId == userId))
        })
      } else {
        this.mapData = this.allList.filter((row) => {
          return ((row.isTrash && !row.trashStaffId) || (row.isClean && !row.cleanStaffId))
        })
      }

      this.staffMap = true
    },

    /**
     * 地図閉じる
     */
    mapClosed() {
      this.staffMap = false
      this.mapData = []
      this.info = ''
    },

    /**
     * カレンダーモーダル
     */
    openCalendar(row) {
      if (!row.siteCode) {
        row.siteCode = row.site_code
      }
      this.siteCalendar = { ...row, startDate: this.filter.startDate }
      this.siteCalendarOpen = true
    },

    /**
     * マスタ編集ボタン
     */
    edit(row) {
      this.modalData = row
      this.modalOpen = true
    },

    /**
     * モーダル閉じる
     */
    closed() {
      this.modalData = null
      this.modalOpen = false
      this.siteCalendar = null
      this.siteCalendarOpen = false
    },

    /**
     * 物件概要書開く
     */
    openOutline(siteCode) {
      const resolvedRoute = this.$router.resolve({
        name: 'SiteOutlineEdit',
        query: {
          siteCode
        }
      })
      window.open(resolvedRoute.href, '_blank')
    },

    /**
     * リフレッシュアイコン
     */
    async refresh(){
      await this.getData()
    },

    /**
     * 検索条件をセッションストレージへ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify(this.filter)
      sessionStorage.setItem(SETTION_STRAGE_NMME, searchStr)
    },

    /**
     *  条件取得
     */
    getCondition() {
      const searchJson = sessionStorage.getItem(SETTION_STRAGE_NMME)
      const getItem = JSON.parse(searchJson)

      if (getItem) {
        this.filter = getItem
      }
      // 途中から加わったもの
      if (this.filter.notDone == undefined) {
        this.filter.notDone = true
      }
      if (this.filter.isChanged == undefined) {
        this.filter.isChanged = 0
      }
      if (this.filter.openBar == undefined) {
        this.filter.openBar = true
      }
      if (!this.filter.staffList || !this.filter.staffList.length) {
        this.filter.staffList = [Number(this.$store.getters.user.id)]
      }
      if (!this.filter.endDate) {
        this.filter.endDate = moment().format('YYYY-MM-DD')
      }
      this.reload++
    },

  },
}
</script>
<style scoped>

.date >>> input {
  height: 38px;
  font-weight: bold;
}

.staff-filter >>> input {
  height: 38px;
  font-weight: bold;
  min-width: 100px;
}

::v-deep .staff1 input[type="text"] {
  font-size: 12px !important;
  font-weight: bold;
}

::v-deep .staff input[type="text"] {
  text-align: center;
  font-size: small !important;
}

::placeholder {
  font-weight: normal;
}

.hover-color:hover {
  background: #fff897;
}

.min-w-1215 {
  min-width: 1215px;
}

.main {
  height: calc(100% - 75px);
  /* min-width: 980px; */
}

.max-table {
  height: calc(100% - 60px);
  /* overflow: auto; */
}

.map-size {
  min-width: 30%;
  max-width: 500px;
}

.bar {
  writing-mode: vertical-rl
}

.staff-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2列 */
  gap: 8px; /* 行・列の間隔 */
}

.z-5 {
  z-index: 5;
}

 /* ページネーション */
#pagenation >>> ul {
  display: flex !important;
  color: rgb(6, 125, 194);
  font-weight: bold !important;
  cursor: pointer;
}

#pagenation >>> ul > li {
  padding: 0 10px;
}

#pagenation >>> ul > .active {
  background: rgb(6, 125, 194);
  color: white;
}

#pagenation >>> p {
  color: gray;
  font-size: small;
}

input[type="checkbox"] {
  color: #0be69d;
}

.z-1 {
  z-index: 1;
}
</style>